import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@shopify/polaris'
import styled from 'styled-components'
import clone from 'lodash/clone'
import isNil from 'lodash/isNil'
import get from 'lodash/get'

import ProductsList from 'components/integrations/ProductsList'
import UICard from '../shopifyUI/UICard'

const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const ButtonContainer = styled.div`
  margin-right: 1em
`
class ProductsSelector extends Component {

  onSelectProduct = (p) => {
    // console.log('onSelectProduct', p)
    const { product, productIdx, updateProduct, setShowcaseImage, onNext } = this.props
    // const oldProductId = product.productId
    const productCopy = clone(product)
    productCopy.productId = p.productId
    productCopy.title = p.title
    updateProduct(productIdx, productCopy)
    if (productIdx === 0) {
      const img = get(p, ['details', 'images', 0])
      if (img) setShowcaseImage(img)
    }
    onNext()
  }

  renderContent () {
    const { product, productIdx } = this.props
    const productId = product.productId
    // console.log('render content', productId)
    return (
      <ProductsList
        productsDict={{}}
        productId={isNil(productId) ? productId : productId.toString()}
        onSelectProduct={this.onSelectProduct}
        availableProducts={[]}
        showNoneProduct={productIdx > 0}
        itemsCountPerPage={12}
      />
    )
  }

  renderBackButton () {
    const { onBack } = this.props
    return (
      <ButtonContainer>
        <Button
          size='slim'
          onClick={onBack}
        >
          {'Back'}
        </Button>
      </ButtonContainer>
    )
  }

  renderRight () {
    const { productIdx, product, onNext } = this.props
    const productId = product.productId
    const isFirst = productIdx === 0
    const nextButtonEnabled = !isNil(productId)
    return (
      <FooterRight>
        {this.renderBackButton()}
        <Button
          primary
          onClick={onNext}
          size='slim'
          disabled={!nextButtonEnabled}
        >
          {isFirst ? 'Done' : 'Next'}
        </Button>
      </FooterRight>
    )
  }

  changeBackgroundImage = () => {
    // console.log('changeBackgroundImage')
    this.props.toChangeBackgroundStep()
  }

  renderActions () {
    const { productIdx } = this.props
    if (productIdx > 0) {
      return [{content: 'Change Background Image', onClick: this.changeBackgroundImage}]
    }
  }

  render () {
    return (
      <UICard
        title='Choose products to create scene'
        description='Select 1-2 products to list for sale on this product scene'
        actions={this.renderActions()}
        content={this.renderContent()}
        footerRight={this.renderRight()}
      />
    )
  }

}

ProductsSelector.propTypes = {
  productIdx: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  updateProduct: PropTypes.func.isRequired,
  setShowcaseImage: PropTypes.func.isRequired,
  toChangeBackgroundStep: PropTypes.func.isRequired
}

export default ProductsSelector



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/ProductsSelector.js